export default __webpack_public_path__ + "static/media/docsend.a69229ee.svg";